module.exports = __webpack_public_path__ + "media/src/application/images/hide-desc-a1e36ea0fc1c6aafaf4bac8b2314fea3.svg";